import { Navigate } from 'react-router-dom'

/**
 * Protege rutas del panel del Sistema (Administrador global).
 * El acceso admin se gestiona con una marca local establecida en el login
 * (usuario "admin"), ya que el administrador no se registra vía Lumi Auth.
 */
function AdminRoute({ children }: { children: React.ReactNode }) {
  const isAdmin = typeof window !== 'undefined' && localStorage.getItem('beeznz_admin') === 'true'

  if (!isAdmin) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default AdminRoute
